import { render, staticRenderFns } from "./CardBodySingleChip.vue?vue&type=template&id=30f1bf76"
import script from "./CardBodySingleChip.vue?vue&type=script&lang=ts"
export * from "./CardBodySingleChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f1bf76')) {
      api.createRecord('30f1bf76', component.options)
    } else {
      api.reload('30f1bf76', component.options)
    }
    module.hot.accept("./CardBodySingleChip.vue?vue&type=template&id=30f1bf76", function () {
      api.rerender('30f1bf76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodySingleChip.vue"
export default component.exports